// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"56":"08e6ee3c","289":"d98e66f5"}[chunkId] + ".css";
};